import axios from 'axios';
import { useState, useEffect } from 'react';

function VideoLikeButton({ videoId, initialLikes }) {
  const [likes, setLikes] = useState(initialLikes);

  useEffect(() => {
    setLikes(initialLikes);
  }, [initialLikes]);

const handleLike = async () => {
  try {
    const response = await axios.post(
      `https://app.reciteontv.com/wp-json/vvt/v1/views/${videoId}/like`
    );

    alert(response.data.message); // show message from backend
    const likeData = await axios.get(
        `https://app.reciteontv.com/wp-json/vvt/v1/views/${videoId}/`
      );
      console.log(likeData.data.likes);
      console.log(response);
    if (response.data.message === "Like counted.") {
      // Fetch updated like count
      const likeData = await axios.get(
        `https://app.reciteontv.com/wp-json/vvt/v1/views/${videoId}/`
      );
        setLikes(likeData.data.likes);
        //console.log("Hello",likeData.data.likes);
    
    }
  } catch (error) {
    console.error('Like failed:', error);
  }
};


  return (
    <span
      title="Click to like"
      onClick={handleLike}
      style={{ cursor: 'pointer' }}
    >
      ❤️ {likes} {likes === 1 ? 'like' : 'likes'}
    </span>
  );
}

export default VideoLikeButton;
